import { render, staticRenderFns } from "./eventOriginStatais.vue?vue&type=template&id=38717040&scoped=true&"
import script from "./eventOriginStatais.vue?vue&type=script&lang=js&"
export * from "./eventOriginStatais.vue?vue&type=script&lang=js&"
import style0 from "./eventOriginStatais.vue?vue&type=style&index=0&id=38717040&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38717040",
  null
  
)

export default component.exports